export const scrollToRef = (ref, options = {}) => {
  if (ref.current) {
    ref.current.scrollIntoView(options);
  }
};
